export const courses = [
    {
        id:1,
        img:"../images/courses/react.png",
        duration :"Duration : 2 months",
        price: "Price : 22999rs"
    },
    {
        id:1,
        img:"../images/courses/angular.jpg",
        duration :"Duration : 2 months",
        price: "Price : 22999rs"
    },
    {
        id:1,
        img:"../images/courses/python.jfif",
        duration :"Duration : 2 months",
        price: "Price : 22999rs"
    },
    {
        id:1,
        img:"../images/courses/datascience.jfif",
        duration :"Duration : 2 months",
        price: "Price : 22999rs"
    },
    // {
    //     id:1,
    //     img:"../images/courses/react.png",
    //     duration :"Duration : 2 months",
    //     price: "Price : 22999rs"
    // },
    // {
    //     id:1,
    //     img:"../images/courses/react.png",
    //     duration :"Duration : 2 months",
    //     price: "Price : 22999rs"
    // },
    // {
    //     id:1,
    //     img:"../images/courses/react.png",
    //     duration :"Duration : 2 months",
    //     price: "Price : 22999rs"
    // },
    // {
    //     id:1,
    //     img:"../images/courses/react.png",
    //     duration :"Duration : 2 months",
    //     price: "Price : 22999rs"
    // }
]